import React, { createContext, useState, useContext, useEffect } from 'react';
import { GetSponsorDetails } from "../services/user-service";
import { useUserContext } from './user/context';

const SponsorContext = createContext<any>(undefined);

export const Sponsor: React.FC<{children: React.ReactElement }> = ({ children }) => {
    const [sponsor, setSponsorDetails] = useState<any>();
     const userInfo = useUserContext();
    useEffect(() => {
        const sponsorId = userInfo?.passplayUser?.sponsorId;
        if (sponsorId) {
            GetSponsorDetails(sponsorId).then((sponsor) => {
                setSponsorDetails(sponsor.data);
               
            });
        }
    }, [userInfo?.passplayUser]);

    return (
        <SponsorContext.Provider value={{ sponsor, setSponsorDetails }}>
            {children}
        </SponsorContext.Provider>
    );
};

export const useSponsorContext = () => {
    const context = useContext(SponsorContext);
    if (context === undefined) {
        throw new Error('useSponsorContext must be used within a SponsorProvider');
    }
    return context;
};